query GetBaseContext {
    userYouAreTalkingTo: loggedInUser {
        id
        name
        emailAddresses {
            id
            address
        }
    }
    nutshellAccount: sessionInstance {
        companyName
    }
    allUsersInThisNutshellAccount: users {
        totalCount
    }
}
